import { Link } from 'react-router-dom';
import { UtensilsCrossed, Mail } from 'lucide-react';

const ADMIN_EMAIL = 'admin@eatfromlocal.com';

export const Footer = () => (
  <footer
    className="border-t border-[#E5E0D8]"
    style={{ backgroundColor: '#F2EFEB' }}
    data-testid="site-footer"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
      <div className="grid gap-8 md:gap-10 grid-cols-2 md:grid-cols-4">
        <div className="col-span-2 md:col-span-2">
          <Link to="/" className="flex items-center gap-2 mb-3" data-testid="footer-logo-link">
            <UtensilsCrossed size={24} strokeWidth={1.5} style={{ color: '#D95A41' }} />
            <span style={{ fontFamily: 'Cormorant Garamond', fontWeight: 600, fontSize: '22px', color: '#1A1A1A' }}>
              eatfromlocal
            </span>
          </Link>
          <p
            style={{ fontFamily: 'Manrope', color: '#5C5C5C', fontSize: '14px', lineHeight: 1.6, maxWidth: '340px' }}
            className="mb-4"
          >
            Homemade food, local love. Discover and order dishes from home cooks in your neighborhood.
          </p>
          <a
            href={`mailto:${ADMIN_EMAIL}`}
            className="inline-flex items-center gap-1.5 hover:underline"
            style={{ fontFamily: 'Manrope', fontSize: '14px', color: '#1A1A1A', fontWeight: 500 }}
            data-testid="footer-email-link"
          >
            <Mail size={14} strokeWidth={1.5} style={{ color: '#D95A41' }} />
            {ADMIN_EMAIL}
          </a>
        </div>

        <div>
          <div className="uppercase mb-4" style={{ fontFamily: 'Manrope', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', color: '#5C5C5C' }}>
            Explore
          </div>
          <ul className="space-y-2.5" style={{ fontFamily: 'Manrope', fontSize: '14px' }}>
            <li><Link to="/" className="hover:underline" style={{ color: '#1A1A1A' }}>Home</Link></li>
            <li><Link to="/listings" className="hover:underline" style={{ color: '#1A1A1A' }}>Browse dishes</Link></li>
            <li><Link to="/blog" className="hover:underline" style={{ color: '#1A1A1A' }} data-testid="footer-blog-link">Blog</Link></li>
          </ul>
        </div>

        <div>
          <div className="uppercase mb-4" style={{ fontFamily: 'Manrope', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', color: '#5C5C5C' }}>
            Company
          </div>
          <ul className="space-y-2.5" style={{ fontFamily: 'Manrope', fontSize: '14px' }}>
            <li>
              <Link to="/contact" className="hover:underline" style={{ color: '#1A1A1A' }} data-testid="footer-contact-link">
                Contact us
              </Link>
            </li>
            <li><Link to="/register" className="hover:underline" style={{ color: '#1A1A1A' }}>Become a cook</Link></li>
            <li><Link to="/privacy" className="hover:underline" style={{ color: '#1A1A1A' }} data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:underline" style={{ color: '#1A1A1A' }} data-testid="footer-terms-link">Terms of Service</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-[#E5E0D8] flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <p style={{ fontFamily: 'Manrope', fontSize: '12px', color: '#5C5C5C' }}>
          © {new Date().getFullYear()} Eat From Local. Made with love in Australia.
        </p>
        <p style={{ fontFamily: 'Manrope', fontSize: '12px', color: '#8A8073' }}>
          Support home cooks. Eat something delicious.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
